<div class="row m-0 p-0">
	<div class="col-2 mt-2" *ngIf="!nonstock">
		<a [routerLink]="'/vendors/create'"  mat-stroked-button color="danger">New Vendor</a>
	</div>
	<div class="col-2 mt-3" *ngIf="user.user.user_group == 1 && !nonstock">
		<mat-slide-toggle [formControl]="disabled">Include Disabled?</mat-slide-toggle>
	</div>

	<div class="col-8 ml-auto mr-0 text-right" [ngClass]="nonstock ? 'col-12' : 'col-md-8'">
		<mat-form-field appearance="outline" >
			<mat-label>Vendor Lookup</mat-label>
			<input matInput #vendorsearch type="text" (input)="onInput()" placeholder="Vendor Search..." [formControl]="vendorSearch"/>
			<span matSuffix>
				<button tabindex="-1" mat-icon-button color="white">
					<mat-icon (click)="onInput()">search</mat-icon>
				</button>
			</span>
		</mat-form-field>
	</div>
</div>
<div class="table">
	<table mat-table [dataSource]="filteredItems" matSort (matSortChange)="announceSortChange($event)"
		[ngClass]="allResults.length ? '' : 'd-none'">

		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let vendor">
				<a mat-stroked-button class="mt-1">View</a>
			</td>
		</ng-container>

		<ng-container matColumnDef="supplierid">
			<th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by vendor">
				Vendor#
			</th>
			<td mat-cell *matCellDef="let vendor">
				<span [innerHTML]="vendor.supplierid | highlight:vendorSearch.value"></span>
			</td>
		</ng-container>

		<ng-container matColumnDef="suppname">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let vendor">
				<span [innerHTML]="vendor.suppname | highlight:vendorSearch.value"></span>
			</td>
		</ng-container>

		<ng-container matColumnDef="address1">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
			<td mat-cell *matCellDef="let vendor">
				<span [innerHTML]="vendor.address1 | highlight:vendorSearch.value"></span>
			</td>
		</ng-container>

		<ng-container matColumnDef="telephone">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Phone#</th>
			<td mat-cell *matCellDef="let vendor">
				<span [innerHTML]="vendor.telephone | highlight:vendorSearch.value"></span>
			</td>
		</ng-container>

		<ng-container matColumnDef="address4">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
			<td mat-cell *matCellDef="let vendor">
				<span [innerHTML]="vendor.address4 | highlight:vendorSearch.value"></span>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="headercolumns; sticky: true;"></tr>
		<tr mat-row *matRowDef="let row; columns: headercolumns;" (click)="selectVendor(row)"></tr>
	</table>
</div>